var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-page>\n<div class=\"page-header\">\n<h1 translate=\"PUBLIC_BOOKING.REGISTER.HEADING\"></h1>\n</div>\n<div ng-form name=\"register_form\" bb-form>\n<div bb-client-details></div>\n<div class=\"col-sm-offset-4 col-sm-5\">\n<button type=\"submit\" class=\"btn btn-primary btn-block\" ng-click=\"submitForm() && checkReady() && routeReady()\" translate=\"PUBLIC_BOOKING.REGISTER.REGISTER_BTN\">\n</button>\n</div>\n</div>\n</div>\n<div class=\"bb-step-navigation\">\n<div class=\"row\">\n<div class=\"col-sm-9 col-sm-push-3 text-right\">\n</div>\n<div class=\"col-sm-3 col-sm-pull-9\">\n<button type=\"button\" class=\"btn btn-default\" bb-debounce ng-click=\"loadPreviousStep()\" ng-show=\"bb.current_step > 1\" translate=\"PUBLIC_BOOKING.CHECK_ITEMS.BACK_BTN\">\n</button>\n</div>\n</div>\n</div>\n";
var id1="member/_templates/steps/register.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/member/_templates/steps/register.html
// module id = 361
// module chunks = 0